//接口请求域名
const API_URL = process.env.API_ROOT;
import $ from 'jquery';
//接口地址
export default{
    loginUrl: API_URL + 'api/uaa/oauth/token',
    ownerData:API_URL + 'api/member/login/index',
    safeCodeUrl: API_URL + 'api/mss/smsCode',
    getAddress:  API_URL + 'api/owner/address/get',
    saveAddress: API_URL + 'api/owner/address/update',
    refreshToken:  API_URL + 'api/uaa/oauth/refresh',
    gettipList: API_URL + 'api/member/tip/index',
    getCountData:API_URL + 'api/owner/tax/cal',
    submitCal:API_URL + 'api/owner/tax/submit',
    deleteAdd:API_URL + 'api/owner/address/delete',
    report:API_URL + 'api/owner/tax/report',
    upload:API_URL + 'api/owner/tax/upload',
    validate:API_URL + 'api/mss/validated',
    refresh:function(fn){
      const key = 'webApp:webApp'
      let authKey = "";
      authKey = 'Basic '+Base64.encode(key);
      let that=this;
      let refresh=localStorage.getItem("refreshToken");
      // console.log(refresh);
      $.ajax({
        url : API_URL + 'uaa/oauth/token',
        type: "POST",
        contentType:"application/x-www-form-urlencoded",
        data:{
          "grant_type":"refresh_token",
          "refresh_token":refresh
        },
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Authorization", authKey);
        },
        success: function(res) {
          // console.log(res);
          let obj={
            access_token:res.access_token,
            usename:res.usename,
            token_type:res.token_type,
            timestamp1:Date.parse( new Date())/1000
          }
          localStorage.setItem('loginData', JSON.stringify(obj));
          localStorage.setItem('refreshToken', res.refresh_token);
          let loginData=JSON.parse(localStorage.getItem("loginData"));
          // console.log(loginData);
          location.reload();
        },

        error:function(res){
            // console.log(res);
              fn()
        }
      })
    },
}



// WEBPACK FOOTER //
// ./src/api/api.js